import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../layout'

export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login'),
    meta: { title: '登录' },
    hidden: true
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/components/404'),
    meta: { title: '404' },
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('../views/home'),
        meta: { title: '首页' }
      }, {
        path: '/hall',
        name: 'Hall',
        component: () => import('../views/hall'),
        meta: { title: '办事大厅' }
      }, {
        path: '/apps',
        name: 'Apps',
        component: () => import('../views/apps'),
        meta: { title: '应用中心' }
      }, {
        path: '/task',
        name: 'Task',
        component: () => import('../views/task'),
        meta: { title: '任务中心' }
      },
    ]
  },
  {
    path: '/guide',
    name: 'Guide',
    component: () => import('../views/guide'),
    meta: { title: '办事指南' }
  },
  {
    path: '/collection',
    name: 'Collection',
    component: () => import('../views/collection'),
    meta: { title: '我的收藏' }
  },
  {
    path: '/handle',
    name: 'Handle',
    component: () => import('../views/handle'),
    meta: { title: '服务办理' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/profile'),
    meta: { title: '个人设置' }
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  if (['/home', '/hall', '/apps', '/task'].includes(from.path)) {
    localStorage.setItem('lastRoute', JSON.stringify({
      path: from.path,
      title: from.meta.title
    }))
  }
  document.title = `一网通办 - ${to.meta.title || ''}`
  next()
})

export default router
